<div class="uk-margin uk-search uk-search-default">
  <button class="uk-search-icon-flip" type="submit" uk-search-icon (click)="search()"></button>
  <form (ngSubmit)="search()">
    <input
      (input)="setParam($any($event.target).value)"
      class="uk-search-input"
      type="search"
      [placeholder]="placeholder"
      [value]="(state | async).params[searchFieldName]" />
  </form>
  <i class="tip" [hidden]="!searchNotApplied" i18n="@@PressEnterForSearch">Press enter for search</i>
</div>
